<template>
<base-modal size="lg" hide-footer hide-header allow-overflow @close="close">
    <div class="col-12" @click.stop="">
        <h4 class="editor-header">{{ $t('areas.add_work_record') }}</h4>
        <div v-if="!areaId || areaId < 1" class="col-12 nopads ps-1">
            <area-filter
                ref="areaFilter"
                :is-admin="false"
                @areaSet="setArea"
            />
        </div>
        <div class="col-sm-12 ps-1 pe-1">
            <span class="span-title">{{ $t('areas.work_time') }}</span>
            <date-time-picker
                class="ml-1 mr-1"
                v-model:date="workTime"
                format="dd.MM.yyyy HH:mm"
                :enableTimePicker="true"
                :placeholder="$t('areas.set_work_time')"
            />
        </div>
        <div class="col-sm-12">
            <span class="span-title">{{ $t('areas.contract') }}</span>
                <open-contract-filter
                    :from="workTime"
                    class="ps-3"
                    :show-company="false"
                    :show-title="false"
                    :apply-padding="false"
                    :showOnlyMyContractsOption="true"
                    :contract="contract"
                    @loading="loading=true"
                    @loadingCompleted="loading=false"
                    @contractSelected="setContract"
                />
        </div>
        <div class="col-sm-12 pb-2 ps-1 pe-1">
            <span class="span-title">{{ $t('areas.task_type') }}</span>
            <contract-order-multiselect
                ref="orderFilter"
                :contract-ids="selectedContract ?  [selectedContract.id] : []"
                :single-mode="true"
                @orders-selected="setOrder"
            />
        </div>
        <div class="col-sm-12 d-flex justify-content-end p-1 pb-3">
            <button
                class="btn btn-sm btn-secondary form-button"
                @click.stop="close"
            >
                {{ $t('common.cancel') }}
            </button>
            <button
                :disabled="!formAreaId || formAreaId < 1 || loading"
                class="btn btn-sm btn-success form-button"
                @click.stop="submitAreaWork"
            >
                {{ $t('common.save') }}
            </button>
        </div>
    </div>
    <div
        v-if="loading"
        id="loader"
        class="spinner"
    />
</base-modal>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from "../../mixins/TimeUtils";
import {orderMixin} from "@/components/mixins/OrderMixin";
import OpenContractFilter from "../../contract/OpenContractFilter";
import AreaFilter from "../AreaFilter";
import DateTimePicker from "@/components/common/DateTimePicker";
import {toRaw} from "vue";
import {inject} from 'vue';
import BaseModal from "@/components/BaseModal";
import ContractOrderMultiselect from "../../order/ContractOrderMultiselect.vue";

export default {
    name: 'AreaWorkEditor',
    components: {
        ContractOrderMultiselect,
        BaseModal, AreaFilter, OpenContractFilter, DateTimePicker},
    mixins: [restApi, orderMixin, timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        },
        areaId: {
            type: Number,
            default: -1
        },
        contract: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            loading: false,
            workTime: null,
            customer: null,
            contractor: null,
            selectedContract: null,
            contracts: [],
            order: null,
            formAreaId: null,
        }
    },
    mounted() {
        this.formAreaId = this.areaId
    },
    methods: {
        setOrder(order) {
            this.order = order
        },
        setContract: function (contract) {
            this.selectedContract = contract
        },
        setDefaultValues: function () {
            let params = {
                end_time: this.workTime,
                start_time: this.workTime
            }
            if(this.selectedContract && this.selectedContract.id) {
                params.contract = {id: this.selectedContract.id}
            }
            if(this.order && this.order.id) {
                params.work_order = {id: this.order.id}
            }
            if(this.formAreaId) {
                params.area = {id: this.formAreaId}
            }
            if(!params.contract) {
                this.showAlert(this.$t('orders.select_contract'))
                return undefined
            }
            if(!params.work_order) {
                this.showAlert(this.$t('orders.select_order'))
                return undefined
            }
            if(!params.area) {
                this.showAlert(this.$t('orders.alert_add_failed'))
                return undefined
            }
            return toRaw(params)
        },
        submitAreaWork: function () {
            let json = this.setDefaultValues()
            if(json) {
                this.loading = true
                this.restAdd(this.areaWorkUrl, json, this.success, this.fail)
            }
        },
        success: function () {
           this.loading = false
           this.$emit('closeAndUpdate')
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        },
        close: function () {
            this.$emit('close')
        },
        setArea(area) {
            this.formAreaId = area
        }
    }
}
</script>
<style scoped>
</style>

